// src/pages/Flights.tsx
import { useState, useEffect } from 'react';
import { Box, Button, Table, Thead, Tbody, Tr, Th, Td, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';
import FlightBookingForm from './FlightBookingForm';
import { createFlightBooking, deleteFlightBooking, getFlightsBooking, updateFlightBooking } from '../../../services/TravelOrders/flightBookigsService';
import { useParams, useSearchParams } from 'react-router-dom';


const FlightBookings = () => {
    const [flights, setFlights] = useState([]);
    const [selectedFlight, setSelectedFlight] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const fetchFlights = async () => {
        const response = await getFlightsBooking();
        setFlights(response.data);
    };

    const [searchParams] = useSearchParams();
    const { flightId } = useParams();

    useEffect(() => {
        if (flightId) {
            const stored = sessionStorage.getItem("selectedFlight");

            if (stored) {
                const flight = JSON.parse(stored);
                if (flight.id === flightId) {
                    setSelectedFlight(flight);
                }

                console.log('offer', flight);
            }
        }
        fetchFlights(); // your existing fetch
    }, [flightId]);

    const handleCreate = async (data: any) => {
        console.log('body', data);
        // await createFlightBooking(data);
        fetchFlights();
        onClose();
    };

    const handleUpdate = async (data: any) => {
        if (selectedFlight) {
            // await updateFlight(selectedFlight._id, data);
            fetchFlights();
            onClose();
        }
    };

    const handleDelete = async (id: string) => {
        await deleteFlightBooking(id);
        fetchFlights();
    };

    return (
        <Box p={5}>
            <FlightBookingForm initialData={selectedFlight} onSubmit={selectedFlight ? handleUpdate : handleCreate} />
        </Box>
    );
};

export default FlightBookings;
